import type {BlobRange} from '@github-ui/blob-anchor'
import {ObservableValue} from '@github-ui/observable'
import {useDerivedObservable, useObservableValue, useObservedState} from '@github-ui/react-observable'
import React, {useEffect} from 'react'

const HighlightedLineContext = React.createContext<ObservableValue<BlobRange | undefined>>(
  new ObservableValue<BlobRange | undefined>(undefined),
)

export function HighlightedLinesProvider({
  highlightedLines,
  children,
}: React.PropsWithChildren<{highlightedLines: BlobRange | undefined}>) {
  const highlight = useObservableValue(highlightedLines)

  useEffect(() => {
    highlight.setValue(highlightedLines)
  }, [highlight, highlightedLines])

  return <HighlightedLineContext value={highlight}>{children}</HighlightedLineContext>
}

export function useHighlightedLinesRange(): BlobRange | undefined {
  return useObservedState(React.use(HighlightedLineContext))
}

export function useHighlightedLinesInfo(lineNumber: number) {
  const highlight = React.use(HighlightedLineContext)

  const highlightForLine = useDerivedObservable(highlight, h =>
    h && lineNumber >= h.start.line && lineNumber <= h.end.line ? h : undefined,
  )

  return useObservedState(highlightForLine)
}
